<template>
    <div class="mt-2">
        <div>
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">
                        fa-certificate
                    </v-icon>
                    Courses
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditPersonCourseDialog />
                <AddPersonCourseDialog :person-id="personId" />
            </v-toolbar>
            <v-data-table
                :headers="courseTableHeaders"
                :items="personCourseListSorted"
                :sort-by.sync="sortBy"
                :sort-desc="true"
                class="elevation-1"
                v-if="person !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">
                            {{props.item.id}}
                        </td>
                        <td class="text-xs-left">
                            {{props.item.courseType != null ? props.item.courseType.name : ""}}
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.title }}
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.description }}
                        </td>
                        <td class="d-sm-table-cell text-xs-left">
                            {{ props.item.startDate | formatDate}}
                        </td>
                        <td class="d-sm-table-cell text-xs-left">
                            {{ props.item.endDate | formatDate}}
                        </td>
                        <td class="d-sm-table-cell text-xs-left">
                            {{ props.item.renewalDate | formatDate}}
                        </td>
                        <td>
                            {{ props.item.comments }}
                        </td>
                        <td
                            class="justify-center layout px-0"
                        >
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                @click="deleteItem(props.item)"
                                small
                                style="display: inline-flex;"
                            >
                                delete
                            </v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>

import { DELETE_PERSON_COURSE, FETCH_PERSON_COURSE_LIST_BY_ID, UPDATE_PERSON_COURSE } from "@/store/person_course/actions";
import { LOAD_PERSON_COURSE_TO_EDIT, RESET_DEFAULT_COURSE_TO_EDIT, TOGGLE_EDIT_PERSON_COURSE_DIALOG, UPDATE_NEW_PERSON_COURSE } from "@/store/person_course/mutations";
import { mapActions, mapGetters, mapMutations } from "vuex";
import EditTableFunctions from '../editTableFunctions';
import AddPersonCourseDialog from "./AddPersonCourseDialog";
import EditPersonCourseDialog from "./EditPersonCourseDialog";

    export default {
        name: "PersonCoursesTable",
        components: {AddPersonCourseDialog, EditPersonCourseDialog},
        mixins: [
            EditTableFunctions,
        ],
        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                idName: 'id',
                dialog: false,
                courseTableHeaders: [
                    {text: 'Id', value: 'id'},
                    {text: 'Type', value: 'courseTypeName'},
                    {
                        text: 'Title',
                        align: 'left',
                        value: 'title',
                    },
                    {
                        text: 'Description',
                        align: 'left',
                        value: 'description',
                    },
                    {text: 'Start Date', value: 'startDate'},
                    {text: 'End Date', value: 'endDate'},
                    {text: 'Renewal Date', value: 'renewalDate'},
                    {
                        text: 'Comments',
                        align: 'left',
                        value: 'comments',
                    },
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                sortBy: 'startDate',
                rowsPerPageItems: [10, 20, 50, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
                pagination: {
                    rowsPerPage: 10
                },
                editedId: -1,
            }
        },

        computed: {
            ...mapGetters(
            [
                "person",
                "personCourseListSorted",
                "courseTypeList",
                "getCourseTypeNameById"
            ]
            )
        },
        mounted() {
        },
        methods: {
            ...mapActions({
                fetchTableList: FETCH_PERSON_COURSE_LIST_BY_ID,
                updateTableItemRecord: UPDATE_PERSON_COURSE,
                deleteTableItem: DELETE_PERSON_COURSE,
            }),
            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_COURSE_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_COURSE_TO_EDIT,
                updateTableItemToEdit: UPDATE_NEW_PERSON_COURSE,
                resetEditItemToDefault: RESET_DEFAULT_COURSE_TO_EDIT,
            })
        },
    }
</script>